import { useNavigate } from 'react-router-dom'
import { DonutChart } from '@carrent/ui'

/** Гаджет: Загрузка автопарка: кольцо. */

export function FleetLoadWidget({ data }) {
  const navigate = useNavigate()
  return (
    <DonutChart
      segments={data.segments}
      total={data.total}
      centerLabel="машин"
      onSelect={(s) => navigate(`/admin/cars?status=${s.key}`)}
    />
  )
}
